module.exports = __webpack_public_path__ + "media/assets/images/tour/4a_Tour_4-2f1d98182fa6a87f4a6154e0e2ea990e.png";